goog.provide('el8.appchart.dialog.mergePatientTags');

goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.mergeTags');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');


el8.appchart.dialog.mergePatientTags = (function() {

	var module = {};

    /**
     * Each call to show() will spawn a new dialog,
     * which will be destroyed when that dialog is hidden. */
    module.show = function(_tag) {
        var tag = _tag;

        var that = new el8.uiwidget.FormDialog({
	        title: 'Patient Tag Merge',
	        modal: false,
	        autoHeight: true,
	        width: 400,
	        contentFn: function() {
	            return el8.template.appchart.dialog.mergeTags.content({'selected': tag.getValue()});
	        }
	    });

	    var form = new el8.uiwidget.Form({
	        fields: [
	            {
	                name: 'findTags',
	                selector: '.findTags',
	                type: 'input',
	                infoText: 'Add tags...',
	                newMindreader: true,
	                maxLength: 100,
	                tagInputOpts: {
	                    mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.availablePtTags(), {
	                        containerLeftOffset: 10,
	                        minQueryLength: 1,
	                        urlParams: {
	                            suppressId: tag.getId(),
	                            includeGlobal: '0'
	                        }
	                    }),
	                    noPromptCreateTag: true
	                }
	            }
	        ]
	    });
	    form.addButton(
	        'merge-tag', 'Merge Tag', function(_form) {
	            var mergeTags = form.getVal('findTags');
	            if (mergeTags.length === 0) {
	                var confirmMsg = 'Please type tag(s) to merge into into ' + tag.getValue() + '.';
	                var createTagFn = function() {
	                };
	                el8.uiwidget.confirm(confirmMsg, createTagFn);
	            }
	            else {
	                var mergeItemText = '';
	                for (var i = 0; i < mergeTags.length; i++) {
	                    if (i > 0) {
	                        if (mergeTags.length > 2) {
	                            mergeItemText += ",";
	                        }
	                        mergeItemText += " ";
	                        if (i === mergeTags.length - 1) {
	                            mergeItemText += "and ";
	                        }
	                    }

	                    var mergeTag = el8.data.patientTags.getById(mergeTags[i]);
	                    mergeItemText += mergeTag.getValue();
	                }

	                var confirmMsg = 'Are you sure you want to merge ' + mergeItemText;

	                confirmMsg += ' into ' + tag.getValue() + '? ' + tag.getValue();
	                confirmMsg += ' will replace ' + mergeItemText;
	                confirmMsg += ' in patient charts and '  + mergeItemText;
	                confirmMsg += ' will be removed from the list. This action cannot be undone!';

	                var createTagFn = function() {
	                     el8.data.patientTags.mergeItem(tag, mergeTags);
	                     that.hide();
	                };

	                el8.uiwidget.confirm(confirmMsg, createTagFn);
	            }

	        }, true
	    );
	    form.addButton(
	        'cancel-merge', 'Cancel', function() {
	            that.hide();
	        }, false
	    );
	    that.setForm(form);

	    var super_hide = that.hide;
        that.hide = function() {
            super_hide.call(that);
            that.destroy();
        };

	    that.show();
    };

    return module;

})();
